export { forgotPasswordEpic as userProfileForgotPasswordEpic } from './epic';
